import { useField } from 'formik';
import { FormsGroup } from './FormsGroup';
import { useFormLabel } from './FormsI18nContext';
import { useTranslation } from 'react-i18next';
import { Select } from 'antd';
import { SelectBlueArrowIcon } from '../CustomIcons';

export interface FormsSelectOption {
  label: string;
  value?: string;
  options?: { label: string; value: string }[];
}

export type FormsSelectProps = {
  name: string;
  label?: React.ReactNode;
  required?: boolean;
  options: FormsSelectOption[];
  mode?: 'multiple';
  showSearch?: boolean;
  disabled?: boolean;
  placeholder?: string;
  suffixIcon?: React.ReactNode;
  allowClear?: boolean;
  onChange?: (value: any) => void;
  maxTagCount?: number | 'responsive';
};

export const FormsSelect = ({
  name,
  label: labelOverride,
  required,
  options,
  mode,
  showSearch,
  disabled = false,
  allowClear = true,
  placeholder,
  suffixIcon,
  onChange,
  maxTagCount,
}: FormsSelectProps) => {
  const { t } = useTranslation();
  const [field, , helpers] = useField(name);
  const label = useFormLabel(name, labelOverride);

  function handleChange(value: string) {
    helpers.setValue(value || null);
    onChange && onChange(value);
  }

  return (
    <FormsGroup label={label} name={name} required={required}>
      <Select
        mode={mode}
        showSearch={showSearch}
        value={field.value}
        onChange={handleChange}
        onBlur={field.onBlur}
        placeholder={placeholder ?? t('selectPlaceholder')}
        optionFilterProp="children"
        allowClear={allowClear}
        suffixIcon={suffixIcon ?? <SelectBlueArrowIcon />}
        disabled={disabled}
        options={options}
        maxTagCount={maxTagCount}
      />
    </FormsGroup>
  );
};
